

























































import { Component, PropSync, Vue } from 'vue-property-decorator';
import UpdateIneConfirmationModalViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-ine/update-ine-confirmation-modal-view-model';

@Component({ name: 'UpdateIneConfirmationModal' })
export default class UpdateIneConfirmationModal extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  update_ine_confirmation_view_model = Vue.observable(
    new UpdateIneConfirmationModalViewModel(),
  );

  closeModal() {
    this.synced_is_open = false;
  }
}
